module.exports = __webpack_public_path__ + "assets/img/solutions.d8c0a9b7.jpg";